import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionState } from './permission.reducer';

export const selectPermissionState = createFeatureSelector<PermissionState>('permissions');

export const selectPermissions = createSelector(
  selectPermissionState,
  (state: PermissionState) => state.permissions
);

export const selectMyProfile = createSelector(
  selectPermissionState,
  (state: PermissionState) => state.myProfile
);

export const selectHeaderTitle = createSelector(
  selectPermissionState,
  (state: PermissionState) => state.headerTitle
);

export const hasPermission = (permissionKey: string) =>
  createSelector(selectPermissions, (permissions: string[]) => {
    if (!permissions || !Array.isArray(permissions)) {
      return false;
    }
    return permissions.includes(permissionKey);
  });
